import React from 'react';
import {
  FDStack, FDBox,
} from '@facet-wealth/design';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import TransitionsDashboardPageLayout
, {
  TransitionsDashboardPageMetaOverride,
} from 'Views/Page/Content/Templates/TransitionsDashboardPage/TransitionsDashboardPage/TransitionsDashboardPage';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import HouseholdInfoSectionPicker from './HouseholdInfoSectionPicker/HouseholdInfoSectionPicker';

const TransitionsDashboardPageTemplate = () => {
  const {
    pageContentResource,
  } = usePageContentContext();

  useBoneBackgroundColor();

  return (
    <FDStack justifyContent={'center'}>
      <FDBox maxWidth={'1800px'}>
        <FDStack direction="column" spacing={2}>
          <HouseholdInfoSectionPicker resource={pageContentResource} />
          <MetaResourceRenderer
            resource={pageContentResource}
            metaOverrideSet={TransitionsDashboardPageMetaOverride}
            layout={TransitionsDashboardPageLayout}
          />
        </FDStack>
      </FDBox>
    </FDStack>
  );
};

TransitionsDashboardPageTemplate.defaultProps = {
};

TransitionsDashboardPageTemplate.propTypes = {
};

export default TransitionsDashboardPageTemplate;
